import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Collection } from '../Collection'
import { ErrorMessage, IsLoading } from '../../components/LoadingOrErrorCollection'
import { Header } from './theme'
import { shouldRender } from '../../utils'

const CollectionWithHeader = ({ title = '', isLoading, errMessage, children }) => (
  <Fragment>
    <Header>{title}</Header>
    <ErrorMessage errMessage={errMessage} />
    <IsLoading isLoading={isLoading} />

    {shouldRender(errMessage, isLoading) && <Collection>{children}</Collection>}
  </Fragment>
)

CollectionWithHeader.propTypes = {
  title: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  errMessage: PropTypes.string,
}

export default CollectionWithHeader



// WEBPACK FOOTER //
// ./src/components/CollectionWithHeader/index.js